import Vue from "vue";
import App from "./App.vue";
import Routes from "./router";
import store from "./store";
import Buefy from "buefy";
import axios from "axios";
import VueAxios from "vue-axios";
import auth from "@websanova/vue-auth";

import httpVueAxios from "@websanova/vue-auth/dist/drivers/http/axios.1.x";
import routerVueRouter from "@websanova/vue-auth/dist/drivers/router/vue-router.2.x";
//import authBasic from "@websanova/vue-auth/dist/drivers/auth/basic";
import myAuth from "./auth/ges_auth";

import moment from "moment";
import vueMoment from "vue-moment";
import "moment/locale/es";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
console.log("BASE URL Axios:", axios.defaults.baseURL);

Vue.use(VueAxios, axios);

const lang = "es";

moment.locale(lang);
Vue.use(vueMoment, { moment });

import "./styles/styles.scss";
Vue.use(Buefy);

Vue.config.productionTip = false;

Vue.router = Routes;

Vue.use(auth, {
  auth: myAuth,
  http: httpVueAxios,
  fetchUser: false,
  router: routerVueRouter,
  loginData: {
    url: "/oauth/token",
    method: "POST",
    //redirect: { name: "Rutas" },
    fetchUser: false,
    rememberMe: true
  },
  refreshData: {
    url: "/oauth/token/refresh",
    method: "POST",
    enabled: false,
    interval: 30
  },
  fetchData: {
    enabled: false
  },
  tokenDefaultKey: "auth_token_default",
  stores: ["storage", "cookie"]
});

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  err => {
    console.log(err);
    console.log("Un-Authorized!!!");
    Vue.auth.logout({
      redirect: { name: "Login" }
    });
    /*if (401 === err.response.status) {
      //console.log('Un-Authorized!!!')
      Vue.auth.logout({
        redirect: { name: "Login" }
      });
    }*/
    return Promise.reject(err);
  }
);

new Vue({
  render: h => h(App),
  store: store,
  router: Routes
}).$mount("#app");
